module.exports = class ProductCategoriesListCtrl
  constructor: ->
    'ngInject'

  $onInit: ->
    @updateTable = @updateTable.bind(@)

  updateTable: ->
    @onRefresh()
